export default "__VITE_ASSET__02b3c7f4__"